import { render, staticRenderFns } from "./FromGocardless.vue?vue&type=template&id=2a5da10f&scoped=true&"
import script from "./FromGocardless.vue?vue&type=script&lang=js&"
export * from "./FromGocardless.vue?vue&type=script&lang=js&"
import style0 from "./FromGocardless.vue?vue&type=style&index=0&id=2a5da10f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5da10f",
  null
  
)

export default component.exports